import { Card, CardBody, Flex, Heading, Stack, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { JSX, ReactElement } from 'react';

type SummaryItemProps = {
  title: string;
  description?: string | JSX.Element | JSX.Element[];
  source?: ReactElement;
  action?: ReactElement;
  color?: string;
  icon?: JSX.Element;
};

export const SummaryItem = ({ title, description, source, action, color, icon }: SummaryItemProps) => {
  return (
    <Card border="none" boxShadow="none" bg="none">
      <CardBody px={0}>
        <Flex direction="column" color={color}>
          <Stack direction="row" align="center">
            {icon}
            <Heading size="xs">{title}</Heading>
          </Stack>
          <Show if={!!description}>
            <Text pt={2} fontSize="sm">
              {description}
            </Text>
          </Show>
          <Show if={!!source}>{source}</Show>
          <Show if={!!action}>{action}</Show>
        </Flex>
      </CardBody>
    </Card>
  );
};
